<script>
import InputPassword from "@/components/ui/InputPassword.vue";
import { 
  UiCompletionCard,
  UiCompletionLine,
  UiCompletionList 
} from "@/components/ui/completion";

export default {
    name: "PasswordFields",
    components: {
        InputPassword,
        UiCompletionCard,
        UiCompletionLine,
        UiCompletionList 
    },
    data: () => ({
        password: '',
        passwordConfirm: '',
    }),
    computed: {
        pwdHasValidLength: function() {
            return this.password.length >= 10;
        },
        pwdHasLowerChar: function() {
            return !!this.password.match(/([a-z])+/);
        },
        pwdHasUpperChar: function() {
            return !!this.password.match(/([A-Z])+/);
        },
        pwdHasNumber: function() {
            return !!this.password.match(/([0-9])+/);
        },
        pwdHasSpecialChar: function() {
            return !!this.password.match(/([#?!@$%^&*-])+/);
        },
        pwdsAreEquals: function() {
            return this.password == this.passwordConfirm;
        },
        pwdsRulesVerified: function() {
            return this.pwdHasValidLength && this.pwdHasLowerChar && this.pwdHasUpperChar && this.pwdHasNumber && this.pwdHasSpecialChar && this.pwdsAreEquals;
        }
    },
    watch: {
        pwdsRulesVerified: function() {
            this.$emit("passwordValidity", { isValid: this.pwdsRulesVerified, pwd: this.password, pwdConfirm: this.passwordConfirm});
        }
    }
}
</script>

<template>
    <div>
        <div class="form-row row-with-label">
          <label>{{ $t('login.password') }}</label>
          <InputPassword v-model="password"/>
        </div>
        <UiCompletionCard>
          <UiCompletionList>
            <UiCompletionLine 
              :is_completed="pwdHasValidLength" 
              :is_required="true"
            >
                {{ $t("login.password_rules.length") }}
            </UiCompletionLine>
            <UiCompletionLine 
              :is_completed="pwdHasLowerChar" 
              :is_required="true"
            >
                {{ $t("login.password_rules.lowercase") }}
            </UiCompletionLine>
            <UiCompletionLine 
              :is_completed="pwdHasUpperChar" 
              :is_required="true"
            >
                {{ $t("login.password_rules.uppercase") }}
            </UiCompletionLine>
            <UiCompletionLine 
              :is_completed="pwdHasNumber" 
              :is_required="true"
            >
                {{ $t("login.password_rules.number") }}
            </UiCompletionLine>
            <UiCompletionLine 
              :is_completed="pwdHasSpecialChar" 
              :is_required="true"
            >
                {{ $t("login.password_rules.special_char") }}
            </UiCompletionLine>
          </UiCompletionList>
        </UiCompletionCard>
        <div class="form-row row-with-label mt-3">
          <label>{{ $t('login.passwordConfirm') }}</label>
          <InputPassword id="passwordConfirm" name="passwordConfirm" v-model.lazy="passwordConfirm"/>
        </div>
        <UiCompletionList>
          <UiCompletionLine 
            :is_completed="pwdsAreEquals" 
            :is_required="true"
          >
            {{ $t("login.password_rules.identical") }}
          </UiCompletionLine>
        </UiCompletionList>
    </div>
</template>
